import Sidepanel from "../Sidepanel/Sidepanel";
import Pagecontent from "../Pagecontent/Pagecontent";
import "./Layout.css";
import React, { useState } from "react";

function Layout() {
  const [IsCompanyOverviewCompleted, setIsCompanyOverviewCompleted] =
    useState(false);

  const [IsFilingCompleted, setIsFilingCompleted] = useState(false);

  const [IsResultCompleted, setIsResultCompleted] = useState(false);

  const updateCompanyState = (companyQuestion) => {
    const allAnswered = companyQuestion?.every((q) => q.selection !== null);
    const isFirstAnswerNo = companyQuestion[0].selection === "No";

    if (isFirstAnswerNo) {
      setIsCompanyOverviewCompleted(true);
      setIsFilingCompleted(true);
      setIsResultCompleted(true);
    } else {
      setIsFilingCompleted(false);
      setIsResultCompleted(false);
      setIsCompanyOverviewCompleted(false);
      if (allAnswered) {
        setIsCompanyOverviewCompleted(true);
      }
    }
  };

  const updateResultState = (resultState) => {
    setIsResultCompleted(resultState);
    setIsFilingCompleted(resultState);
  };

  return (
    <>
      <div className="layout-container">
        <div className="layout-container-header"></div>

        <div className="layout-container-content">
          <div className="sidepanel">
            <Sidepanel
              IsCompanyOverviewCompleted={IsCompanyOverviewCompleted}
              IsFilingCompleted={IsFilingCompleted}
              IsResultCompleted={IsResultCompleted}
            />
          </div>
          <div className="page-content">
            <Pagecontent
              updateCompanyState={updateCompanyState}
              updateResultState={updateResultState}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Layout;
